import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceDetails from './components/ServiceDetails';
import ProcessSection from './components/ProcessSection';
import ServicesCTA from './components/ServicesCTA';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const servicesJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'IT Services - VORENN TECH',
    description: 'Explore VORENN TECH\'s full range of IT services including IT consulting, cloud migration, business support, advertisement & marketing, and SMM management services.',
    url: `${SITE_URL}/services`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'VORENN TECH IT Services',
    itemListElement: [
      {
        '@type': 'ListItem', position: 1,
        item: {
          '@type': 'Service',
          name: 'IT Consulting',
          description: 'Strategic IT guidance to align technology with your business goals and drive digital transformation.',
          url: `${SITE_URL}/service/it-consulting`,
          provider: { '@type': 'Organization', name: 'VORENN TECH' },
          offers: { '@type': 'Offer', price: '299', priceCurrency: 'USD' },
        },
      },
      {
        '@type': 'ListItem', position: 2,
        item: {
          '@type': 'Service',
          name: 'Cloud Migration',
          description: 'Seamless transition to cloud infrastructure with minimal downtime and maximum efficiency.',
          url: `${SITE_URL}/service/cloud-migration`,
          provider: { '@type': 'Organization', name: 'VORENN TECH' },
          offers: { '@type': 'Offer', price: '599', priceCurrency: 'USD' },
        },
      },
      {
        '@type': 'ListItem', position: 3,
        item: {
          '@type': 'Service',
          name: 'Business Support Services',
          description: 'Comprehensive administrative support and process optimization to enhance operational efficiency.',
          url: `${SITE_URL}/service/business-support-services`,
          provider: { '@type': 'Organization', name: 'VORENN TECH' },
          offers: { '@type': 'Offer', price: '349', priceCurrency: 'USD' },
        },
      },
      {
        '@type': 'ListItem', position: 4,
        item: {
          '@type': 'Service',
          name: 'Advertisement & Marketing Services',
          description: 'Strategic marketing campaigns and brand development to grow your business reach.',
          url: `${SITE_URL}/service/advertisement-marketing-services`,
          provider: { '@type': 'Organization', name: 'VORENN TECH' },
          offers: { '@type': 'Offer', price: '449', priceCurrency: 'USD' },
        },
      },
      {
        '@type': 'ListItem', position: 5,
        item: {
          '@type': 'Service',
          name: 'SMM Management Services',
          description: 'Expert social media strategy and community engagement to build your online presence.',
          url: `${SITE_URL}/service/smm-management-services`,
          provider: { '@type': 'Organization', name: 'VORENN TECH' },
          offers: { '@type': 'Offer', price: '399', priceCurrency: 'USD' },
        },
      },
    ],
  },
];

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="IT Services - IT Consulting, Cloud Migration & Business Support | VORENN TECH"
        description="Explore VORENN TECH's professional IT services: IT consulting, cloud migration, business support, advertisement & marketing, and SMM management. Packages from $299 to $599."
        keywords="IT consulting services, cloud migration, business support, advertisement marketing, SMM management, VORENN TECH"
        canonical="/services"
        jsonLd={servicesJsonLd}
      />
      <Navbar />
      <ServicesHero />
      <ServiceDetails />
      <ProcessSection />
      <ServicesCTA />
      <Footer />
    </div>
  );
};

export default ServicesPage;